import { createContext, useContext } from "react";
import type { Doctor } from "../interfaces";
import { useDoctor } from "../hooks";
import { MekiDocSplashScreen } from "../components";

const DoctorContext = createContext<Doctor | null>(null);

export const useDoctorContext = () => {
  const currentUser = useContext(DoctorContext);

  if (!currentUser) {
    throw new Error("DoctorContext: No value provided");
  }

  return currentUser;
};

export const DoctorContextProvider = ({ children }: { children: React.ReactNode }) => {
  const { data: doctor, isPending, isError } = useDoctor();

  if (isPending) {
    return <MekiDocSplashScreen />;
  }

  if (isError) {
    // TODO: Add a better Error Screen (logout user, show error message, etc.)
    return <>Error...</>;
  }

  return <DoctorContext.Provider value={doctor}>{children}</DoctorContext.Provider>;
};
